/** @file The PoseAt the stores describe: a mix preview, else the playhead in Animate mode, else setup. */
import type { SkeletonData } from '@pose2d/core/types';
import { currentDoc } from '../stores/currentDoc';
import { docStore } from '../stores/docStore';
import { playheadStore } from '../stores/playheadStore';
import { toolStore } from '../stores/toolStore';
import { mixPreviewStore } from './mixPreviewStore';
import type { PoseAt } from './poseAt';

const SETUP: PoseAt = { kind: 'setup' };

/**
 * Read once per viewport frame; an animation the compiled data does not hold yet (a rename in flight) shows setup.
 * A mix run built on other data (a recompile the clock has not stepped yet) is skipped: its indices may be stale.
 */
export function currentPoseAt(data: SkeletonData): PoseAt {
  const run = mixPreviewStore.getState().run;
  if (run !== null && run.data === data) return { kind: 'mix', state: run.state };
  const doc = currentDoc(docStore.getState());
  const { animation, frame } = playheadStore.getState();
  if (doc === null || animation === null || toolStore.getState().mode !== 'animate') return SETUP;
  const name = doc.animations[animation]?.name;
  const anim = name === undefined ? undefined : data.animationIndex.get(name);
  return anim === undefined ? SETUP : { kind: 'animation', anim, time: frame / doc.meta.fps };
}
